import { Component, OnInit, ViewChild, Input, OnDestroy } from "@angular/core";
import { Platform } from "@ionic/angular";
import { take, filter } from 'rxjs/operators';
import { GeoResponse } from "src/app/interfaces/geo-interface";
import { CustomerModel } from "src/app/models/customer-model";
import { AuthenticationService } from "src/app/services/authentication/authentication.service";
import { BannerService } from "src/app/services/banner/banner.service";
import { isUndefined } from "src/app/services/codeUtils";
import { ConfigService } from "src/app/services/config/config.service";
import { EventsService } from "src/app/services/event/event.service";
import { JurisdictionService } from "src/app/services/geo/jurisdiction.service";
import { TimeService } from "src/app/services/time-service/time.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { Navigator } from "../menu/navigator";
import { NavigationEnd, Router } from "@angular/router";
import { BiometricService } from "src/app/services/biometric/biometric.service";
import { FundsIndicatorService } from "src/app/services/funds-indicator/funds-indicator.service";
import { BalanceModel } from "src/app/models/balance-model";
import { AccountBalanceService } from "src/app/services/balance/account-balance.service";
import { LobbyNavigator } from "src/app/services/lobby/lobby-navigator.service";

@Component({
  selector: "app-site-header",
  templateUrl: "./site-header.component.html",
  styleUrls: ["./site-header.component.scss"],
})

export class SiteHeaderComponent implements OnInit, OnDestroy {
  @ViewChild("mainMenuPopover") mainMenuPopover;
  @ViewChild("secondaryMenuPopover") secondaryMenuPopover;
  @Input() tab: String;

  public currentTime: any;
  public currentTimeTS: any;
  public firstLoginTime: any;
  public intervalId;
  public isLiveDealer = false;
  public isSports = false;
  public isMobileApp = false;
  public isIosWeb = false;
  public isAuthenticated: boolean = false;
  public onlineTime: any;
  public userSubscription: any;
  public timeServiceSubscription: any;
  public PIPE_DATE_FORMAT: any;
  public serverTime: any;
  public syncTimeInterval;
  public timeSinceLastTimeCall: Date = null;
  public timeDifferenceToTheMinute: number = 0;
  public timeDifferenceToTheSeconds: number = 0;
  public displayRGLogo: boolean;
  public showDevelopButton: boolean = false;
  public showBalance: boolean = true;
  public balance: any;

  constructor(
    public authenticationService: AuthenticationService,
    public bannerService: BannerService,
    public config: ConfigService,
    public events: EventsService,
    public jurisdiction: JurisdictionService,
    public navigator: Navigator,
    public userSessionService: UserSessionService,
    public timeService: TimeService,
    public router: Router,
    public biometric: BiometricService,
    private eventsService: EventsService,
    private platform: Platform,
    private fundsIndicatorService: FundsIndicatorService,
    private lobbyNavigator: LobbyNavigator,
    private accountBalanceService: AccountBalanceService
  ) {
    this.PIPE_DATE_FORMAT = !!this.config.getConfig().FEATURE_TIME_FORMAT_TO
      ? this.config.getConfig().FEATURE_TIME_FORMAT_TO
      : "yyyy/MM/dd hh:mm a";

    this.showBalance = this.fundsIndicatorService.showBalance;
    this.eventsService.subscribe("event:balanceState", data => this.updateBalanceState(data));
  }

  ngOnInit() {
    this.verifyAuth();
    this.checkSession();
    this.setUserTime();
    this.events.subscribe("event:login", () => {
      this.verifyAuth();
      this.setUserTime();
    });

    this.isMobileApp = this.platform.is("capacitor");
    this.isIosWeb = this.platform.is("ios") && this.platform.is("mobileweb");
    this.router.events
    .pipe(filter((event) => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
      if (this.isMobileApp) {
        this.checkRoutes(event.url);
      }
    });
    
    this.eventsService.subscribe("action:changeTab", (tabName) => {
      if(tabName == 'casino' && !this.isMobileApp){
        this.lobbyNavigator.setKeyword(this.lobbyNavigator.getCasinoDefaultKeyword());
        this.navigator.toTab(tabName, true, this.lobbyNavigator.getCasinoDefaultKeyword()?.keyword_route);
      } else {
        this.navigator.toTab(tabName, true);
      } 
      this.verifyAuth();
    });

    this.eventsService.subscribe("event:authentication:logout", () => {
      this.verifyAuth();
    });

    this.eventsService.subscribe("event:config:reload", () => {
      console.log("config reloaded!", this.config.getClientApp());
    });

    this.eventsService.subscribe("event:tabs:load", (tab, data?) => {
      if (isUndefined(data)) data = false;
      this.navigator.toTab(tab, data);
    });

    this.displayRGLogo = this.config.getConfig().FEATURE_SHOW_RG_LOGO === '1' ? true : false;

  }

  ngOnDestroy() {
    if (this.userSubscription) this.userSubscription.unsubscribe();
  }

  setUserTime() {
    this.onlineTime = null;
    this.serverTime = null;
    if (this.intervalId) clearInterval(this.intervalId);
    if (this.userSubscription) this.userSubscription.unsubscribe();
    this.userSubscription = this.userSessionService.getCustomer().pipe(filter(value => value != undefined),
      take(1)).subscribe((customer: CustomerModel) => {
        if (customer) {
          this.timeFunction(customer.currentLoginTime).then((data) => {
            if (data) {
              let difference: any = data;
              this.timeDifferenceToTheSeconds =
                60 - new Date(difference * 1000).getSeconds();
              setTimeout(() => {
                this.timeFunction(customer.currentLoginTime);
                if (this.intervalId) {
                  clearInterval(this.intervalId);
                }
                this.intervalId = setInterval(() => {
                  this.timeFunction(customer.currentLoginTime);
                }, 60000);
              }, this.timeDifferenceToTheSeconds * 1000);
            }
          });
        }
      });
  }

  verifyAuth() {
    this.userSessionService.isAuthenticated().then((isAuthenticated) => {
      this.isAuthenticated = isAuthenticated;
      if (!!isAuthenticated) this.getBalance();
    });
  }

  checkRoutes(url: string) { 
    this.isLiveDealer = false;
    this.isSports = false;
    console.log('url', url);
    if (url.includes('/live-dealer') && this.isAuthenticated) {
      this.isLiveDealer = true;
    } else if (url.includes('/sports')) {
      this.isSports = true;
     }
  }

  public navigateTo(page: string, options?, params?) {
    return this.navigator.navigateTo(page, options, params);
  }

  public initGeo() {
    this.jurisdiction
      .verifyJurisdiction(() => this.geoConsole())
      .then((geoResp: GeoResponse) => { })
      .catch((err: any) => { });
  }

  public geoConsole() {
    console.log("Geo is Running");
  }

  public onLogoClick() {
    return this.navigator.toCasino();
  }

  public checkSession() {
    if (this.intervalId) clearInterval(this.intervalId);
    const userStatus = { sessionToken: "", customerId: 12 };
    if (!!this.canCallTheService("checkSession")) {
      this.authenticationService.checkSession().then((sessionResult) => {
        if (!!sessionResult.subject) {
          sessionResult.subject.subscribe({
            next: (response) => {
              if (!isUndefined(response.result) && !!response.result) {
                this.userSessionService.setSessionToken(
                  sessionResult.sessionToken
                );
                userStatus.sessionToken = sessionResult.sessionToken;
              }
              this.userSessionService
                .refreshCustomer()
                .subscribe((customer: CustomerModel) => {
                  userStatus.customerId = customer.customerId;
                  this.bannerService.fetchAllBanners();
                  this.events.publish("event:appInit:init", {
                    triggeredBy: "REFRESH",
                  });
                  this.userSessionService.setUserStatus(userStatus);
                });
            },
            error: (error) => {
              if (
                error &&
                "error_code" in error &&
                error.error_code == "hasExceededDepositLimit"
              ) {
                this.userSessionService.clear();
              }
            }
          });
          return;
        }
        return this.userSessionService.clear();
      });
    }
  }

  timeFunction(currentLoginTime?) {
    return new Promise((resolve, reject) => {
      if (this.timeServiceSubscription) this.timeServiceSubscription.unsubscribe();
      this.timeServiceSubscription = this.timeService.callTime().subscribe(
        (currentTime) => {
          if (currentTime.result == 1) {
            let createDate = new Date(currentLoginTime);
            this.firstLoginTime = Date.parse(String(createDate));
            this.serverTime = currentTime.payload.full;
            this.currentTimeTS = currentTime.payload.ts;
            let loggedInTime = this.firstLoginTime || this.currentTimeTS;
            this.onlineTime = this.timeService.getTimeOnline(
              this.currentTimeTS,
              loggedInTime
            );
            this.timeService.setOnlineTime(this.onlineTime);
            this.timeSinceLastTimeCall = new Date();
            clearInterval(this.syncTimeInterval);

            this.syncTimeInterval = setInterval(() => {
              //console.log("sync time called");
              const now = new Date();
              const diff = now.getTime() - this.timeSinceLastTimeCall.getTime();
              const adjustedServerDate = new Date(
                this.currentTimeTS * 1000 + diff
              );
              this.currentTime =
                (adjustedServerDate.getMonth() < 10 ? "0" : "") +
                (adjustedServerDate.getMonth() + 1) +
                "/" +
                adjustedServerDate.getDate() +
                "/" +
                adjustedServerDate.getFullYear() +
                " " +
                adjustedServerDate.getHours() +
                ":" +
                (adjustedServerDate.getMinutes() < 10 ? "0" : "") +
                adjustedServerDate.getMinutes() +
                " " +
                currentTime.payload.full.substr(-3);
            }, 1000);
          }
          resolve(this.currentTimeTS);
        },
        (error) => {
          resolve(0);
        }
      );
    });
  }

  async onLogin() {
    if (this.platform.is('capacitor')) {
      const loginSucess = await this.biometric.biometricLoginInitiator();
      if (!loginSucess) this.navigator.navigateTo('LoginComponent', "", { biometricVerificationFailed: true });
    } else {
      return this.navigateTo('LoginComponent')
    }
  }

  public onJoin(): any {
    return this.navigateTo('SignupStepOneComponent');
  }

  canCallTheService(funcName) {
    let isAllowed = true;
    switch (funcName) {
      case "checkSession":
        let hash = document.location.hash;
        if (hash !== "" && (hash == "#show-page" || ~hash.indexOf("#paypal") || ~hash.indexOf("#interac-return"))) {
          isAllowed = false;
        }
        break;
    }
    return isAllowed;
  }

  private getBalance() {
    this.accountBalanceService.getBalance().subscribe((response: BalanceModel) => {
      this.balance = response;
    });
  }

  public updateBalanceState(data) {
    this.showBalance = data.show;

    const code = (!isUndefined(data.code)) ? data.code : "";
    if (code == 'IN_GAME') return this.showBalance = false;
  }
}
